import * as moment from 'moment-timezone';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { ScrollService } from '../../core/scroll.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { ChecklistStep, ChecklistStepRoute } from '../pnel-cts-checklist/model/checklist-steps';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { MyTestSessionsSetupService } from '../my-test-sessions-setup.service';
import { AuthService, DB_TIMEZONE } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { ITestWindow } from '../../api/models/db/test_windows.schema';

interface ITestWindowSelection { 
  setupId: string,
  testWindowId: number,
}

interface ITestWindowInfo {
  id: number,
  title: string,
  notes: string,
  from: string,
  to: string,
}

@Component({
  selector: 'view-cts-test-window',
  templateUrl: './view-cts-test-window.component.html',
  styleUrls: ['./view-cts-test-window.component.scss']
})
export class ViewCtsTestWindowComponent implements OnInit, OnDestroy {

  public testWindows:ITestWindowInfo[] = []; 
  
  public breadcrumb = [];
  public setupId:string;
  public isLoaded:boolean;

  public isTestWindowSelected:boolean;
  public selectedTestWindowId:number;
  public mySetupSub:Subscription;
  private routeSub:Subscription;

  constructor(
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    public lang:LangService,
    private auth:AuthService,
    private routes:RoutesService,
    private mySetup: MyTestSessionsSetupService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.setupId = routeParams['setupId'];
      this.breadcrumb = this.mySetup.generateBreadcrumbs(this.setupId, 'page_cts_test_window_mid_h');
      this.initRouteView();
    });
  }

  initRouteView(){
    this.mySetupSub = this.mySetup.sub().subscribe(setupInfo => {
      if (setupInfo){
        this.selectedTestWindowId = setupInfo.testWindowId;
        this.isTestWindowSelected = setupInfo.checkTestWindow;
        this.loadTestWindows();
      }
    });
  }

  ngOnDestroy() {
    if (this.mySetupSub){ this.mySetupSub.unsubscribe(); }
  }

  loadTestWindows(){
    this.auth
      .apiFind( this.routes.TEST_ADMIN_TEST_SESSION_SETUP_TEST_WINDOWS, {})
      .then( (windowsPaginated: {data:ITestWindow[]}) => {
        this.testWindows = [];
        this.isLoaded = true;
        windowsPaginated.data.forEach( testWindow => {
          this.testWindows.push({
            id: testWindow.id,
            title: testWindow.title,
            notes: testWindow.notes,
            from: this.renderWindowDate(<string>testWindow.date_start),
            to: this.renderWindowDate(<string>testWindow.date_end),
          })
        })
      })
  }

  getCurrentStepId(){
    return ChecklistStep.TestWindow
  }

  gotoNextRoute(){
    const nextRouteSuffix = ChecklistStepRoute.Location;
    let breadcrumb = this.breadcrumbsService.TESTADMIN_CREATE_TEST_SESSION(this.setupId, nextRouteSuffix);
    this.router.navigate([ breadcrumb.route ]);
  }

  renderWindowDate(dbDate:string){
    return moment.tz(dbDate, DB_TIMEZONE).format('dddd h:mma') + '\n'
         + moment.tz(dbDate, DB_TIMEZONE).format('MMMM D, YYYY')
  }

  selectTestWindow(testWindow:ITestWindowInfo){
    const patchConfig:ITestWindowSelection = {
      setupId: this.setupId,
      testWindowId: testWindow.id,
    }
    this.auth
      .apiPatch(this.routes.TEST_ADMIN_TEST_SESSION_SETUP_TEST_WINDOWS, null, patchConfig)
      .then( res => {
        this.mySetup.refresh();
        this.gotoNextRoute();  
      })
      .catch(e => {
        alert(this.lang.tra('unexpected_error'))
      })
  }

  isReadyToContinue(){
    return this.mySetup.getChecklistStepState(ChecklistStepRoute.TestWindow);
  }

}
